// extracted by mini-css-extract-plugin
module.exports = {"property":"ProductProperty_property__yNeOq","label":"ProductProperty_label__zocQd","value":"ProductProperty_value__uLFmh","bigValue":"ProductProperty_bigValue__f1Ab6"};